module.exports = __webpack_public_path__ + "media/images/dashboard/dark/tile_icon_phone_number_usage-dc4d5e6e2bc808d3e85256133b6e4054.png";